import { Employee } from '../associates/employee.model';
import { WarrantySubmissionType } from './warranty-submission-type.model';
import { ServiceGroup } from './service-group.model';

export class AppointmentCase {
  addedByPowerlane: boolean = null;
  addedFromServiceSchedule = false;
  appointmentId: number = null;
  campaignAddedBySystem: string = null;
  campaignNumber: string = null;
  caseFromQuote = false;
  cause: string = null;
  correction: string = null;
  embedded?: AppointmentCaseEmbed = null;
  employeeId: string = null;
  estimatedTime: number = null;
  mappedServiceGroup: string = null;
  mileageInterval: number = null;
  monthInterval: number = null;
  opCode: string = null;
  partsKitMaintenanceId: number = null;
  quoteCaseNumber: number = null;
  recommendedHours: number = null;
  requestDescription: string = null;
  sequence?: number = null;
  serviceGroupId: string = null;
  startTime: Date = null;
  technicianGroupId: number = null;
  technicianGroupName: string = null;
  technicianId: string = null;
  vehicleScheduleServiceGroupsSequence?: number = null;
  vehicleScheduleServiceGroupsServiceGroupIdSequence?: number = null;
  vehicleScheduleServiceGroupsVehicleId?: number = null;
  warrantySubmissionTypeId: string = null;

  constructor(obj?: AppointmentCase) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

class AppointmentCaseEmbed {
  employee?: Employee = null;
  warrantySubmissionType?: WarrantySubmissionType = null;
  serviceGroup?: ServiceGroup = null;
}
